// import { REHYDRATE } from 'redux-persist/constants'
import _omit from 'lodash/omit';

const initialState = {
    items: [],
    codes: [],
    shoppertrack: null,
    couponInProcess: false,
    couponSuccess: '',
    couponError: {},
    couponDeleteError: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        // case 'persist/REHYDRATE':
        // 	console.log(state, action)
        // 	return state

        // ===================================
        //  SET CART DATA
        // ===================================
        case 'SET_CART':
            let new_cart = {
                ...state,
                ...action.payload,
            };
            if (
                new_cart.hasOwnProperty('shipping_method') &&
                !Object.keys(new_cart.shipping_method).length
            )
                delete new_cart.shipping_method;
            return new_cart;

        // ===================================
        //	ADD PRODUCT
        // ===================================
        case 'ADD_CART_IN_PROCESS':
            return {
                ...state,
                inProccess: true,
            };

        case 'ADD_CART_SUCCESS':
            let returningState = {
                ...action.payload.cart,
                cart_summary: action.payload.cart_summary,
                shoppertrack: action.payload.customer,
                inProccess: false,
                success: action.payload.message,
            };

            return returningState;

        case 'ADD_CART_ERROR':
            return {
                ...state,
                inProccess: false,
                error: action.error,
            };

        // ===================================
        //	UPDATE QTY
        // ===================================
        case 'UPDATE_CART_QTY_IN_PROCESS':
            return {
                ..._omit(state, ['updateError', 'updateSuccess']),
                updateInProcess: true,
                updatedId: action.item_id,
            };

        case 'UPDATE_CART_QTY_SUCCESS':
            let updatedState = {
                // ...state,
                ...action.payload.cart,
                cart_summary: action.payload.cart_summary,
                shoppertrack: action.payload.customer,
                updateInProcess: false,
                updateSuccess: action.payload.message,
                updatedId: action.item_id,
            };

            // If no items in case, reset the items property to empty array
            if (!action.payload.cart.items) {
                updatedState = {
                    ...updatedState,
                    items: [],
                };
            }

            return updatedState;

        case 'UPDATE_CART_QTY_ERROR':
            return {
                ...state,
                updateInProcess: false,
                updateError: action.error,
                updatedId: action.item_id,
            };

        case 'CLEAR_UPDATE_MESSAGES':
            return _omit(state, [
                'updateInProcess',
                'updateError',
                'updatedId',
                'updateSuccess',
            ]);

        // ===================================
        //	DELETE PRODUCT
        // ===================================
        case 'REMOVE_FROM_CART_IN_PROCESS':
            return {
                ...state,
                deleteInProcess: true,
                deletedId: action.item_id,
            };

        case 'REMOVE_FROM_CART_SUCCESS':
            let deletedState = {
                // ...state,
                ...action.payload.cart,
                cart_summary: action.payload.cart_summary,
                shoppertrack: action.payload.customer,
                deleteInProcess: false,
                deleteSuccess: action.payload.message,
                deletedId: action.item_id,
            };

            // If no items in case, reset the items property to empty array
            if (!action.payload.cart.items) {
                deletedState = {
                    ...deletedState,
                    items: [],
                };
            }

            return deletedState;

        case 'REMOVE_FROM_CART_ERROR':
            return {
                ...state,
                deleteInProcess: false,
                deleteError: action.error,
                deletedId: action.item_id,
            };

        // ===================================
        //	ADD COUPON
        // ===================================
        case 'ADD_COUPON_CART_IN_PROCESS':
            return {
                ...state,
                couponInProcess: true,
                couponError: {},
                couponSuccess: '',
            };

        case 'ADD_COUPON_CART_SUCCESS':
            return {
                ...action.payload.cart,
                cart_summary: action.payload.cart_summary,
                shoppertrack: action.payload.customer
                    ? action.payload.customer
                    : state.shoppertrack,
                couponInProcess: false,
                couponSuccess: action.payload.message,
            };

        case 'ADD_COUPON_CART_ERROR':
            // console.log(action)
            return {
                ...state,
                couponInProcess: false,
                couponError: action.error,
            };

        // ===================================
        //	DELETE COUPON
        // ===================================
        case 'REMOVE_COUPON_FROM_CART_IN_PROCESS':
            return {
                ...state,
                deleteInProcess: true,
                deletedId: action.item_id,
                couponDeleteError: '',
            };

        case 'REMOVE_COUPON_FROM_CART_SUCCESS':
            let deletedCouponState = {
                ...state,
                ...action.payload.cart,
                cart_summary: action.payload.cart_summary,
                deleteInProcess: false,
                deleteSuccess: action.payload.message,
                deletedId: action.item_id,
            };

            // If no items in case, reset the items property to empty array
            if (!action.payload.cart.items) {
                deletedCouponState = {
                    ...deletedCouponState,
                    items: [],
                };
            }

            return deletedCouponState;

        case 'REMOVE_COUPON_FROM_CART_ERROR':
            return {
                ...state,
                deleteInProcess: false,
                couponDeleteError: action.error,
                deletedId: action.item_id,
            };

        // ===================================
        //	BASIC UPDATE
        // ===================================
        case 'UPDATE_CART':
            return {
                ...state,
                ...action.payload.cart,
                cart_summary: action.payload.cart_summary,
            };

        // ===================================
        //	CLEAR
        // ===================================
        case 'CLEAR_SUCCESS':
            return _omit(state, [
                'success',
                'updateInProcess',
                'updateError',
                'updatedId',
                'updateSuccess',
                'deleteInProcess',
                'deleteError',
                'deletedId',
                'deleteSuccess',
            ]);

        case 'CLEAR_DELETE_MESSAGES':
            return _omit(state, [
                'deleteInProcess',
                'deleteError',
                'deletedId',
                'deleteSuccess',
                'couponDeleteError',
                'couponSuccess',
            ]);

        case 'CLEAR_CART':
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cart.js